import { DashboardType, DashboardSize } from '../types/Dashboard';

export type FormFactor = 'tile' | 'graph' | 'table' | 'hero';

// Tiles são para single-value / KPI visuals que cabem em espaços pequenos.
// Pie/donut precisam de mais espaço (legenda, fatias), então vão como graph.
const TILE_TYPES: ReadonlySet<DashboardType> = new Set(['gauge', 'gauge-multiple', 'metric']);
const GRAPH_TYPES: ReadonlySet<DashboardType> = new Set(['line', 'bar', 'stacked-bar', 'area', 'scatter', 'pie', 'donut']);
const TABLE_TYPES: ReadonlySet<DashboardType> = new Set(['table']);

export function getFormFactor(type: DashboardType | undefined): FormFactor {
  if (!type) return 'graph';
  if (TILE_TYPES.has(type)) return 'tile';
  if (GRAPH_TYPES.has(type)) return 'graph';
  if (TABLE_TYPES.has(type)) return 'table';
  return 'graph';
}

export function isCompatible(slotFormFactor: FormFactor, type: DashboardType | undefined): boolean {
  return getFormFactor(type) === slotFormFactor;
}

const SIZE_RANK: Record<DashboardSize, number> = {
  small: 1,
  medium: 2,
  large: 3,
  full: 4,
};

export function compareSizes(a: DashboardSize, b: DashboardSize): number {
  return SIZE_RANK[a] - SIZE_RANK[b];
}
